import { render, staticRenderFns } from "./iconLetter.vue?vue&type=template&id=b4bcc7e2&scoped=true"
import script from "./iconLetter.vue?vue&type=script&lang=js"
export * from "./iconLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bcc7e2",
  null
  
)

export default component.exports